import axios from '@axios'

export default {
  getNumerologies() {
    return axios.get('/api/numerologies')
  },
}
